import { css } from "@vitality-ds/system";
export default css({
  display: "inline-grid",
  gridTemplateColumns: "repeat(5, max-content)",
  alignItems: "center",
  gap: "$md"
});